// Mock data for Mamamina's Soul Feed - inspired by Girl & the Goat structure

export const restaurantInfo = {
  name: "Mamamina's Soulfeed",
  tagline: "Brisbane's taste of Liberia — bold flavours, big culture, authentic West African food.",
  rating: {
    google: { score: 4.9, count: 38 },
    ubereats: { score: 4.9, count: 120 }
  },
  priceRange: "",
  halal: true,
  website: "https://www.mamaminassoulfeed.online/",
  address: {
    line1: "1422 Beaudesert Road",
    line2: "Acacia Ridge, QLD 4110",
    mapUrl: "https://maps.google.com/?q=1422+Beaudesert+Road+Acacia+Ridge+QLD"
  },
  hours: [
    { label: "Monday", days: "", time: "3:30pm – 9:00pm" },
    { label: "Tuesday", days: "", time: "12:00pm – 9:00pm" },
    { label: "Wednesday", days: "", time: "12:00pm – 9:00pm" },
    { label: "Thursday", days: "", time: "12:00pm – 9:00pm" },
    { label: "Friday", days: "", time: "12:00pm – 10:00pm" },
    { label: "Saturday", days: "", time: "12:00pm – 10:00pm" },
    { label: "Sunday", days: "", time: "12:00pm – 9:00pm" }
  ],
  contact: {
    phone: "+61735684708",
    phoneDisplay: "(07) 3568 4708",
    mobile: "+61478770550",
    mobileDisplay: "0478 770 550",
    email: "Mamaminasoulfood@gmail.com"
  },
  social: {
    instagram: "https://instagram.com/mamaminassoulfeed_",
    facebook: "https://www.facebook.com/p/MamaMinas-Soulfeed-61560695544095/",
    tiktok: "https://tiktok.com/@mamaminassoulfeed_",
    google: "https://share.google/vCsLcQr3mVjSkcxwi"
  },
  delivery: [
    {
      name: "Uber Eats",
      url: "https://www.ubereats.com/brisbane/food-delivery/mamaminassoulfeed-acacia-ridge/Ep1o6MbYVtWo_h5-eDDWaw/",
      tagline: "4.9★ · 120+ reviews"
    },
    {
      name: "DoorDash",
      url: "https://www.doordash.com/store/38321423/",
      tagline: "Order & track in the app"
    },
    {
      name: "KRAVEiN",
      url: "https://www.kravein.com.au/order-food/mamaminassoulfeed",
      tagline: "Direct from the kitchen"
    }
  ]
};

// Real photos from Mamamina's Soul Feed
const MM_SPREAD = "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/mkkcow2t_IMG_1755.webp";
const MM_FUFU_EGUSI = "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/orr4fegv_IMG_1773.webp";
const MM_RICE_BITTERLEAF = "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/bvfr9oik_IMG_1785.webp";
const MM_FUFU_OXTAIL = "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/xrhxotj9_IMG_1786.webp";
const MM_SPINACHRICE = "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/g7q3qjk5_IMG_1787.webp";

export const heroImages = [MM_SPREAD, "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/x5z3xb1h_IMG_1784.webp", "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/400cysd2_IMG_1783.webp"];

export const aboutImages = {
  chef: MM_FUFU_EGUSI,
  spread: MM_SPREAD
};

export const aboutText = `Mamamina's Soulfeed brings Brisbane its taste of Liberia — authentic West African cuisine crafted with traditional spices, slow-cooked with love and served with heart. Every dish carries the warmth of home: peppery, patient, generous. From soulful pepper soup and hand-pounded fufu to our famous grilled fish and plantains, we honour the recipes we grew up with. 100% halal. Come as strangers, leave as family.`;

export const happenings = [
  {
    id: 1,
    title: "Attieké Feast Platter",
    subtitle: "Chef's Signature",
    description: "Our showpiece — whole grilled tilapia over fluffy cassava attieké with sweet plantain, eggs, avocado, tomato, cucumber and every sauce we make. Built to be shared, or held to your chest.",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/x5z3xb1h_IMG_1784.webp",
    cta: "Reserve"
  },
  {
    id: 2,
    title: "Skewer Night",
    subtitle: "Every Friday from 5pm",
    description: "Beef and chicken skewers, marinated overnight in our house spice blend and flame-grilled to order. Paired with Mamamina's homemade ginger and live afrobeats.",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/jgvtz40f_IMG_1774.webp",
    cta: "Reserve"
  },
  {
    id: 3,
    title: "Fish & Plantains",
    subtitle: "Featured Dish",
    description: "A Mamamina classic — a whole tilapia seasoned in our house blend, your choice of oven baked or crispy fried, served with golden sweet plantains and our signature pepper sauce on the side. Simple, soulful and made to be devoured.",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/400cysd2_IMG_1783.webp",
    cta: "Reserve"
  }
];

export const menuLookupKeys = {
  1: "mamamina_attieke_feast",
  2: "mamamina_fish_plantains",
  3: "mamamina_beef_skewers",
  4: "mamamina_chicken_skewers",
  5: "mamamina_chicken_shawarma",
  7: "mamamina_pepper_soup_fufu",
  8: "mamamina_check_rice",
  9: "mamamina_okra_soup_fufu",
  10: "mamamina_fried_chicken",
  11: "mamamina_kala_puff_puff",
  12: "mamamina_fried_plantains",
  13: "mamamina_dry_rice",
  14: "mamamina_potato_leaf",
  15: "mamamina_torbogee",
  16: "mamamina_peanut_soup",
  17: "mamamina_palava_sauce",
  18: "mamamina_liberian_fried_rice",
  19: "mamamina_whole_fish",
  20: "mamamina_beef_shawarma",
  21: "mamamina_mixed_shawarma",
  22: "mamamina_kids_meal",
  30: "mamamina_bundle_family_feast",
  31: "mamamina_bundle_soul_duo",
  32: "mamamina_bundle_shawarma_pack"
};

// Menu item IDs that get a "Popular" flame badge on the menu.
export const popularMenuIds = [1, 2, 7, 9, 16, 17];

// Family bundles / meal deals
export const familyBundles = [
  {
    id: 30,
    name: "Family Feast Bundle",
    tagline: "For 4 – 5 hungry souls",
    description: "1 whole fish (grilled or fried), 1 pepper soup with fufu, 1 palava sauce with rice, 4 sides of fried plantains, 4 puff puff. Save $25.",
    price: "$150",
    originalPrice: "$175",
    lookup_key: "mamamina_bundle_family_feast",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/mkkcow2t_IMG_1755.webp"
  },
  {
    id: 31,
    name: "Soul Duo",
    tagline: "Dinner for two",
    description: "Choose any 2 mains, share 1 side of plantains, and 1 Mina's Homemade Ginger to wash it down. Save $10.",
    price: "$85",
    originalPrice: "$95",
    lookup_key: "mamamina_bundle_soul_duo",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/x5z3xb1h_IMG_1784.webp"
  },
  {
    id: 32,
    name: "Shawarma Party Pack",
    tagline: "6 wraps + shared chips",
    description: "6 shawarma wraps (any combo of chicken, beef or mixed), 2 large bowls of chips, 6 house drinks. Feeds 6. Save $15.",
    price: "$105",
    originalPrice: "$120",
    lookup_key: "mamamina_bundle_shawarma_pack",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/b3zycsqz_IMG_1771.webp"
  }
];

// Recipe blog placeholder posts
export const blogPosts = [
  {
    slug: "why-pepper-soup",
    title: "Why our pepper soup is a religion in Liberia",
    excerpt: "It's not just food — it's medicine, memory, and Sunday afternoons rolled into one bowl.",
    date: "Recent",
    readMins: 4,
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/orr4fegv_IMG_1773.webp",
    body: [
      "Pepper soup means different things depending on who's stirring the pot. For us, it's what mama makes when someone in the family is under the weather — a broth so bright with scotch bonnet and warm spice it clears the head before it even hits your lips.",
      "In Liberia, pepper soup is served across occasions: a wedding, a funeral, a Sunday afternoon with cousins on plastic chairs in the yard. It's always the same three moves — meat, broth, fufu — but the seasoning is what makes each family's version their own. Ours has been passed down three generations.",
      "At Mamamina's, we simmer the broth low and slow with uziza leaves, ehuru and calabash nutmeg, then finish it with a squeeze of fresh lime. Serve it with a soft, hand-pounded fufu ball and you have Liberia on a plate."
    ]
  },
  {
    slug: "how-attieke-earned-its-crown",
    title: "How attiéké quietly became our signature",
    excerpt: "The cassava couscous that started as a side has become the platter everyone Instagrams.",
    date: "Recent",
    readMins: 3,
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/x5z3xb1h_IMG_1784.webp",
    body: [
      "When we opened, attiéké was on the menu as a small side. Within a month, customers were asking for it as the main event.",
      "So we built it up. Whole tilapia, fried plantain, boiled egg, avocado, tomato, cucumber, red onion, and every sauce we make — piled over fluffy cassava attiéké on one giant platter. It's messy in the best way. Eat it with your fingers, share it with friends, order more ginger juice.",
      "It's now our most-photographed dish. Every second Instagram post from someone's Sunday date-night has it in the frame. We're not mad about it."
    ]
  },
  {
    slug: "meet-mamamina",
    title: "Meet Mamamina — the woman behind the pot",
    excerpt: "From Monrovia to Acacia Ridge, this is how our little kitchen came to be.",
    date: "Recent",
    readMins: 5,
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/mkkcow2t_IMG_1755.webp",
    body: [
      "Mamamina cooked her first pot of jollof at nine years old. By fifteen she was feeding her whole neighbourhood at every wedding and funeral in Monrovia.",
      "She arrived in Brisbane with two suitcases, a couple of children, and the recipes her grandmother had drilled into her over decades. For years she cooked for anyone who missed home — students, drivers, mates of mates who'd heard through the grapevine that mama could make cassava leaves taste the way it did back home.",
      "In 2024 we finally opened Mamamina's Soulfeed. The idea was simple: serve Liberian food that tastes like it did in mama's kitchen — no compromises, no shortcuts, no watering things down. Just soul, on a plate, for whoever wants a taste."
    ]
  }
];

// Suburb SEO landing pages
export const suburbPages = [
  {
    slug: "acacia-ridge",
    suburb: "Acacia Ridge",
    postcode: "4110",
    zone: "Zone 1",
    fee: 10,
    range: "0 – 2 km",
    intro: "You're basically our next-door neighbours in Acacia Ridge. Order Liberian food from Mamamina's Soulfeed and mama's driver will have it at your door in 20 minutes."
  },
  {
    slug: "sunnybank",
    suburb: "Sunnybank",
    postcode: "4109",
    zone: "Zone 1",
    fee: 10,
    range: "3 – 5 km",
    intro: "Sunnybank foodies — you already know good food travels. Get authentic Liberian pepper soup, attiéké and grilled fish delivered fresh from our Acacia Ridge kitchen."
  },
  {
    slug: "inala",
    suburb: "Inala",
    postcode: "4077",
    zone: "Zone 2",
    fee: 15,
    range: "5 – 8 km",
    intro: "Inala — one of Brisbane's most beautifully multicultural pockets. Bring West Africa to your table with soul food that's cooked slow and served generous."
  }
];

export const menuHighlights = [
  {
    id: 1,
    name: "Attieké Feast Platter",
    description: "Whole grilled tilapia over cassava attieké with fried plantain, eggs, avocado, cucumber, tomato, red onion and our house pepper sauce & mayo.",
    price: "$65",
    tag: "Signature",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/x5z3xb1h_IMG_1784.webp"
  },
  {
    id: 2,
    name: "Fish & Plantains",
    description: "Whole tilapia — your choice of grilled or fried — served with sweet plantains and our house pepper sauce.",
    price: "$40",
    tag: "Signature",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/400cysd2_IMG_1783.webp"
  },
  {
    id: 3,
    name: "Beef Skewers",
    description: "Tender beef marinated in our house spice blend, char-grilled with capsicum and red onion. Served with peppery dipping sauce.",
    price: "$20",
    tag: "Grill",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/jgvtz40f_IMG_1774.webp"
  },
  {
    id: 4,
    name: "Chicken Skewers",
    description: "Juicy chicken thigh in mamamina's spice rub, grilled over open flame with green capsicum and onion. Served with signature chilli sauce.",
    price: "$20",
    tag: "Grill",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/lly00mc3_IMG_1789.webp"
  },
  {
    id: 5,
    name: "Chicken Shawarma",
    description: "Chicken marinated in our house spice blend, wrapped in a soft warm flatbread with fresh tomatoes, lettuce, cucumber and our creamy spicy mayo. Served with crispy golden chips on the side.",
    price: "$20",
    tag: "Wraps",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/b3zycsqz_IMG_1771.webp"
  },
  {
    id: 20,
    name: "Beef Shawarma",
    description: "Beef marinated in our house spice blend, wrapped in a soft warm flatbread with fresh tomatoes, lettuce, cucumber and our creamy spicy mayo. Served with crispy golden chips on the side.",
    price: "$20",
    tag: "Wraps",
    image: "/media/dishes/beef_shawarma.jpg"
  },
  {
    id: 21,
    name: "Mixed Shawarma",
    description: "Chicken and beef together, marinated in our house spice blend and wrapped in a soft warm flatbread with fresh tomatoes, lettuce, cucumber and our creamy spicy mayo. Served with crispy golden chips on the side.",
    price: "$20",
    tag: "Wraps",
    image: "/media/dishes/mixed_shawarma.jpg"
  },
  {
    id: 7,
    name: "Pepper Soup & Fufu",
    description: "A spicy and aromatic West African soup infused with traditional herbs, chilli, and warming spices. Made with tender meat, this flavourful broth is perfect for those who enjoy a bold, fiery kick. Served with hand-pounded fufu.",
    price: "$40",
    tag: "West African",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/orr4fegv_IMG_1773.webp"
  },
  {
    id: 8,
    name: "Check Rice",
    description: "Tender chicken slow-cooked in mamamina's rich, savoury gravy, served over a bed of fluffy basmati rice.",
    price: "$40",
    tag: "West African",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/bvfr9oik_IMG_1785.webp"
  },
  {
    id: 9,
    name: "Okra Soup & Fufu",
    description: "A classic West African soup made with fresh okra, cooked in a rich, savoury base with tender meat. Lightly textured, flavourful, and perfect with rice or fufu.",
    price: "$40",
    tag: "West African",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/g7q3qjk5_IMG_1787.webp"
  },
  {
    id: 10,
    name: "Mamamina's Fried Chicken",
    description: "Buttermilk-brined chicken wings dredged in our house spice, fried golden and crackling. Served with our signature pepper sauce for dipping.",
    price: "$15",
    tag: "Signature",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/gh7hczlx_IMG_1791.webp"
  },
  {
    id: 11,
    name: "Kala / Puff Puff",
    description: "Golden, pillowy West African doughnuts \u2014 lightly sweet, fried to order and served with pepper sauce on the side. The way mama makes them.",
    price: "$15",
    tag: "Sides",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/uhuevroa_IMG_1772.webp"
  },
  {
    id: 12,
    name: "Fried Plantains",
    description: "Sweet, ripe plantains fried until golden and caramelised at the edges. Served with our house pepper sauce.",
    price: "$15",
    tag: "Sides",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/f0e0k05m_IMG_1757.webp"
  },
  {
    id: 13,
    name: "Dry Rice",
    description: "A hearty Liberian classic \u2014 fluffy dry rice served with fried fish, fried chicken, sweet plantains and a boiled egg, finished with our house-made pepper sauce, warm palm red oil and traditional Liberian spices.",
    price: "$40",
    tag: "Liberian",
    image: "/media/dishes/dry_rice.jpg"
  },
  {
    id: 14,
    name: "Potato Leaf",
    description: "A traditional Liberian potato leaf stew \u2014 your choice of fried or slow-cooked in palm oil \u2014 simmered with tender meat and warm spice. Deep, earthy and comforting. Served with rice.",
    price: "$40",
    tag: "Liberian",
    image: "/media/dishes/potato_leaf.jpg"
  },
  {
    id: 15,
    name: "Torbogee",
    description: "A classic Liberian stew made with bitter balls or beans, simmered in palm oil with assorted meats and traditional spices. Deep, earthy flavours with a rich and satisfying taste.",
    price: "$40",
    tag: "Liberian",
    image: "/media/dishes/torbogee.jpg"
  },
  {
    id: 16,
    name: "Peanut Soup",
    description: "A creamy, hearty peanut soup slow-simmered with meat and warm West African spices. Served with your choice of fufu or rice.",
    price: "$40",
    tag: "Liberian",
    image: "/media/dishes/peanut_soup.jpg"
  },
  {
    id: 17,
    name: "Palava Sauce",
    description: "A wholesome West African dish made from molokhia leaves, cooked in palm oil with peppers, onions, and your choice of meat. Nutritious, flavourful, and full of authentic taste.",
    price: "$40",
    tag: "Liberian",
    image: "/media/dishes/palava_sauce.jpg"
  },
  {
    id: 18,
    name: "Liberian Special Fried Rice & Chicken",
    description: "Our house-style fried rice loaded with vegetables and warm spice, served with tender seasoned chicken. A Mamamina crowd favourite.",
    price: "$35",
    tag: "Liberian",
    image: "/media/dishes/liberian_special_fried_rice.jpg"
  },
  {
    id: 19,
    name: "Whole Fish \u2014 Grilled or Fried",
    description: "A whole tilapia seasoned in our house blend \u2014 your choice of oven baked or crispy fried. Served with pepper sauce on the side.",
    price: "$35",
    tag: "Signature",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/400cysd2_IMG_1783.webp"
  },
  {
    id: 22,
    name: "Kids Meal",
    description: "A little plate for little souls \u2014 fluffy rice, mama's fried chicken and sweet plantains, gently spiced. Pair with any Kids drink for a $10 flat combo.",
    price: "$12",
    tag: "Kids",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_soul-food-table/artifacts/gh7hczlx_IMG_1791.webp"
  }
];

export const catering = {
  headline: "Bring the feast to you.",
  intro: "From backyard birthdays and weddings to corporate events and community gatherings — Mamamina's brings authentic Liberian & West African flavours anywhere in South East Queensland.",
  services: [
    {
      title: "Private Catering",
      description: "Custom menus for private events, celebrations, weddings and corporate functions. Buffet-style, shared platters or plated service — we tailor to your vibe.",
      icon: "utensils"
    },
    {
      title: "Food Trailer",
      description: "Book our food trailer for festivals, markets, parties and pop-ups. Fully equipped kitchen on wheels serving hot, fresh soul food on-site.",
      icon: "truck"
    },
    {
      title: "Private Events",
      description: "Reserve the restaurant or a section of it for birthdays, engagements, or intimate dinners. Live afrobeats and a menu curated by mama herself.",
      icon: "sparkles"
    }
  ],
  cta: "Enquire now"
};

export const beverages = {
  featured: [
    {
      name: "Mina's Homemade Ginger",
      description: "Mama's own house-made ginger cooler, shaken with fresh lime. Punchy, bright, non-alcoholic.",
      price: "$8",
      lookup_key: "mamamina_drink_mina_ginger",
      image: "https://images.unsplash.com/photo-1612201961930-07d09780d039?crop=entropy&cs=srgb&fm=jpg&q=85"
    },
    {
      name: "Fresh Coconut Water",
      description: "Straight from the coconut \u2014 cold, hydrating and naturally sweet.",
      price: "$8",
      lookup_key: "mamamina_drink_coconut_water",
      image: "https://images.unsplash.com/photo-1588413336019-dd5d3beddf55?crop=entropy&cs=srgb&fm=jpg&q=85"
    },
    {
      name: "Tropical Pineapple",
      description: "Chilled pineapple juice \u2014 pure sunshine in a glass.",
      price: "$7",
      lookup_key: "mamamina_drink_tropical_pineapple",
      image: "https://images.unsplash.com/photo-1600271886742-f049cd451bba?crop=entropy&cs=srgb&fm=jpg&q=85"
    }
  ],
  groups: [
    {
      title: "Soft Drinks",
      items: [
        { name: "Coke", price: "$4", lookup_key: "mamamina_drink_coke" },
        { name: "Coke Zero", price: "$4", lookup_key: "mamamina_drink_coke_zero" },
        { name: "Fanta", price: "$4", lookup_key: "mamamina_drink_fanta" },
        { name: "Solo", price: "$4", lookup_key: "mamamina_drink_solo" }
      ]
    },
    {
      title: "Malts",
      items: [
        { name: "Malt", price: "$4", lookup_key: "mamamina_drink_malt" },
        { name: "Vimto", price: "$4", lookup_key: "mamamina_drink_vimto" }
      ]
    },
    {
      title: "Bundaberg Range",
      items: [
        { name: "Bundaberg Ginger Beer", price: "$6", lookup_key: "mamamina_drink_bund_ginger_beer" },
        { name: "Bundaberg Lemonade", price: "$6", lookup_key: "mamamina_drink_bund_lemonade" },
        { name: "Bundaberg Passionfruit", price: "$6", lookup_key: "mamamina_drink_bund_passionfruit" },
        { name: "Bundaberg Pineapple", price: "$6", lookup_key: "mamamina_drink_bund_pineapple" },
        { name: "Bundaberg Coconut", price: "$6", lookup_key: "mamamina_drink_bund_coconut" },
        { name: "Bundaberg Guava", price: "$6", lookup_key: "mamamina_drink_bund_guava" }
      ]
    },
    {
      title: "Hydration",
      items: [
        { name: "Gatorade", price: "$5", lookup_key: "mamamina_drink_gatorade" },
        { name: "Still Water", price: "$6", lookup_key: "mamamina_drink_still_water" }
      ]
    },
    {
      title: "For the Kids",
      items: [
        { name: "Kids Juice Popper", price: "$3", lookup_key: "mamamina_drink_kids_popper" },
        { name: "Kids Fruit Drink", price: "$3", lookup_key: "mamamina_drink_kids_fruit" }
      ]
    }
  ]
};

// Short Liberian-English glossary printed on the back of the physical menu.
export const menuGlossary = [
  { term: "Fufu", meaning: "Soft, stretchy dough of pounded cassava. Tear off a piece and dip it into your soup." },
  { term: "Attieké", meaning: "Fluffy fermented-cassava couscous from Côte d'Ivoire — light, slightly tangy." },
  { term: "Pepper soup", meaning: "Light, fiery broth of meat or fish simmered with warming West African spices." },
  { term: "Palava sauce", meaning: "Rich greens stew of molokhia leaves cooked down in palm oil with meat or fish." },
  { term: "Torbogee", meaning: "Classic Liberian stew of bitter balls or beans slow-simmered in palm oil with meats." },
  { term: "Potato leaf", meaning: "Sweet-potato greens slow-cooked in palm oil — Liberia's everyday comfort dish." },
  { term: "Check rice", meaning: "Rice cooked together with chopped greens and seasonings. A Liberian staple." },
  { term: "Dry rice", meaning: "Fluffy rice served \u201cdry\u201d (no soup) with fried fish and sweet plantains." },
  { term: "Kala / Puff puff", meaning: "Sweet, pillowy fried doughnut balls — best dunked in pepper sauce." },
  { term: "Plantain", meaning: "The savoury cousin of the banana, fried until golden, caramelised and sweet." }
];


export const deliveryInfo = {
  headline: "Private Delivery",
  minOrder: 150,
  areas: "South East Queensland",
  note: "Delivery fee is calculated by distance from our Acacia Ridge kitchen. Enter your postcode below for an instant quote. Order direct via phone or email — mama's own driver brings the feast to your door."
};

// Distance-based delivery zones (from 1422 Beaudesert Rd, Acacia Ridge 4110)
// Fees in AUD. Postcodes covered per zone.
export const deliveryZones = [
  {
    zone: "Zone 1",
    range: "0 – 5 km",
    fee: 10,
    areas: "Acacia Ridge, Coopers Plains, Sunnybank, Salisbury, Moorooka, Rocklea, Nathan",
    postcodes: ["4110", "4108", "4109", "4111", "4105", "4106"]
  },
  {
    zone: "Zone 2",
    range: "5 – 10 km",
    fee: 15,
    areas: "Sunnybank Hills, Runcorn, Kuraby, Calamvale, Algester, Parkinson, Woodridge, Kingston, Inala, Durack, Doolandella",
    postcodes: ["4112", "4113", "4114", "4115", "4116", "4117", "4077", "4078"]
  },
  {
    zone: "Zone 3",
    range: "10 – 15 km",
    fee: 20,
    areas: "Underwood, Browns Plains, Springwood, Rochedale, Mansfield, Wishart, Holland Park, Greenslopes, Coorparoo, Yeronga, Annerley, Forest Lake, Richlands",
    postcodes: ["4118", "4119", "4120", "4121", "4122", "4123", "4127", "4102", "4104", "4074", "4076"]
  },
  {
    zone: "Zone 4",
    range: "15 – 20 km",
    fee: 25,
    areas: "Daisy Hill, Cornubia, Loganholme, Shailer Park, Slacks Creek, Beenleigh, Camp Hill, Carindale, Mount Gravatt, Chandler, Wellington Point",
    postcodes: ["4128", "4129", "4130", "4131", "4152", "4155", "4157", "4207"]
  },
  {
    zone: "Zone 5",
    range: "20 – 30 km",
    fee: 35,
    areas: "Cleveland, Capalaba, Ormiston, Waterford, Bethania, Loganlea, Marsden, Crestmead, Ipswich, Brisbane CBD, Bulimba",
    postcodes: ["4132", "4133", "4160", "4163", "4165", "4300", "4301", "4305", "4000", "4171"]
  }
];

export const deliveryDefaultFee = { fee: 50, label: "Outer SEQ (30+ km)" };

export const googleReviews = [
  {
    name: "Mary Ball",
    rating: 5,
    date: "21 hours ago",
    text: "The taste of the food is top notch and the quality of the service is excellent. Friendly and professional staff."
  },
  {
    name: "Yamal K",
    rating: 5,
    date: "4 days ago",
    text: "Yummy yummy. Excellent and unique food. One of the best in Brisbane! Bring your friends and family here."
  },
  {
    name: "Warwick Walker",
    rating: 5,
    date: "2 weeks ago",
    text: "Amazing food. Amazing people. We splurged and got all of our favourite Liberian dishes. Was not disappointed! I grew up in Liberia — please support this amazing food and beautiful people. Highly recommend the pepper soup, potato greens, peanut soup, dry rice and fish, and jollof rice."
  },
  {
    name: "Yovella Palacios",
    rating: 5,
    date: "3 weeks ago",
    text: "Food full of so many flavours and spices, mama fed me till I was full. The atmosphere was quaint with the rustic paintings, tinted windows and draped decor — the place really sets a scene that accompanies the vibrant taste of the food."
  },
  {
    name: "Kamil Elferkh",
    rating: 5,
    date: "5 weeks ago",
    text: "My wife and I turned up at Mamamina's purely at random. OMG how bloody good is their food. We loved every mouthful and can't wait to have the opportunity to return."
  },
  {
    name: "MaJose Navarrete",
    rating: 5,
    date: "7 weeks ago",
    text: "The food was amazing! It was my first time trying Liberian food, and I absolutely loved it. The portions were very generous, and everything was delicious."
  },
  {
    name: "Ali Mokrani",
    rating: 5,
    date: "13 weeks ago",
    text: "Man this place is a vibe. Hospitality, cleanliness, service all top notch. Oh yeah and their food is banging as well. Highly recommend."
  },
  {
    name: "Sommer Lee",
    rating: 5,
    date: "17 weeks ago",
    text: "Fantastic night with great service and delicious food!! We were out having a girls night out and wanted to try something new — Mamamina's was the perfect place. Looking forward to returning soon!"
  },
  {
    name: "Camilla Metzger",
    rating: 5,
    date: "19 weeks ago",
    text: "First timer. We had the pepper soup with fufu, and the beef and chicken skewers. Both absolutely exceptional! Honestly, so many flavours hitting me at once. My palate is once again happy!"
  },
  {
    name: "Faiz Z",
    rating: 5,
    date: "19 weeks ago",
    text: "Had my first fufu here and I was not disappointed at all. The fufu with the palava sauce was absolutely delicious. And the lady with the long braids who served us was so lovely and friendly."
  },
  {
    name: "Nikki Blackmore",
    rating: 5,
    date: "19 weeks ago",
    text: "Family run, and absolutely spectacular food. We came to have a change up in dinner options and loved the vibes, the chef and the pepper soup / skewer dishes. Highly recommended."
  },
  {
    name: "Grace Maz",
    rating: 5,
    date: "25 weeks ago",
    text: "The food was amazing and delicious. What touched me the most was the quality of the food and just how fresh it looked, felt and tasted. Amazing, Amazing, Amazing. The customer service was also 10/10."
  }
];

export const pressQuotes = [
  { source: "Yovella Palacios · Google Review", quote: "Food full of so many flavours and spices, mama fed me till I was full." },
  { source: "Sommer Lee · Google Review", quote: "Fantastic night with great service and delicious food!!" },
  { source: "Camilla Metzger · Google Review", quote: "We had the pepper soup with fufu, and the beef and chicken skewers." }
];
